export const PRIORITY_LABELS: Record<string, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  critical: 'Critical',
};

export const SOURCE_TYPE_LABELS: Record<string, string> = {
  spec: 'Spec',
  backlog: 'Backlog',
  todo: 'To-Do',
  goal: 'Tagesziel',
};

export const ASSIGNEE_LABELS: Record<string, string> = {
  michael: 'Michael',
  melli: 'Melli',
  'michael-agent': 'Michaels Agent',
  'melli-agent': 'Mellis Agent',
};

const LEGACY_ASSIGNEE_MAP: Record<string, string> = {
  agent: 'michael-agent',
};

export function normalizeAssignee(assignee: string): string {
  return LEGACY_ASSIGNEE_MAP[assignee] ?? assignee;
}

export type AssigneeFilterType = 'all' | 'user' | 'agent';

export function isAgentAssignee(assignee: string | null | undefined): boolean {
  if (!assignee) return false;
  const normalized = normalizeAssignee(assignee);
  return normalized.endsWith('-agent');
}

export function getAssigneeLabel(assignee: string | null | undefined): string {
  if (!assignee) return 'Michael';
  const normalized = normalizeAssignee(assignee);
  return ASSIGNEE_LABELS[normalized] ?? normalized;
}
